<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="page container" v-else-if="loaded" >
        
        <div class="mt-3 d-none" >
            <ul class="horizontal-menu " > 
                <li>  <router-link :to="{name: 'Integration', params: { APP: 'FACEBOOK' } }" class="not-active pl-0" > <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back </router-link>  </li>
                <li class="float-right" >
                        
                    <span v-if="data.last_update" class="font-300 font-size-14 line-height-31 mr-2" > Last updated at: <b > {{formatData(data.last_update)}} </b> </span>

                    

                    <span v-else-if="editable" >
                        <b-button type="submit" variant="primary" class="btn btn-sm" > <font-awesome-icon :icon="['far', 'save']" class="mr-1" />  Save </b-button>    
                        <b-button @click="edit" v-if="type == 'edit'" variant="outline-secondary" class="btn btn-sm" > <font-awesome-icon :icon="['fa', 'times']" class="mr-1" />  Cancel </b-button>    
                    </span>
                    
                </li>
            </ul>
        </div>
        
        <div class="row position-relative mt-3" >
            
            <b-dropdown v-if="!editable"  size="sm" html='Actions <svg aria-hidden="true" class="atlass-icon icon-chevron-down fill-white" height="14" width="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.591 5.293a1 1 0 0 1 1.416 1.416l-6.3 6.3a1 1 0 0 1-1.414 0l-6.3-6.3A1 1 0 0 1 2.41 5.293L8 10.884z" fill-rule="evenodd"></path></svg>' variant="primary" right split-variant class="font-size-14 position-absolute right-0 mt-3 mr-4">
                
                <b-dropdown-item-button @click="FB_getpermissions()" class="d-none"  > Check permissions </b-dropdown-item-button>
                
                <b-dropdown-item-button v-if="data.Status" @click="toggleSwitch( 'Status', false )"   >Deactivate</b-dropdown-item-button>
                <b-dropdown-item-button v-else-if="!data.Status" @click="toggleSwitch( 'Status', true )"  >Activate</b-dropdown-item-button>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item-button variant="danger" @click="preventDelete()" >Delete</b-dropdown-item-button>
            </b-dropdown>
            
            <div class="col-12 text-center" v-if="type == 'add' "  >
                
                <h4 class="col-12 mt-5" > Connect your Facebook account to access your ads manger and import ad accounts </h4>
                
                <div class="col-12 mt-3" >
                    
                    <button 
                        type="button" 
                        class="btn btn-primary btn-facebook w-auto mt-2" 
                        @click="fblogin"
                        v-if=" data.authResponse.accessToken == '' "
                    >
                        <span><font-awesome-icon :icon="['fab', 'facebook']" /></span> 
                        Log in With Facebook
                    </button>
                    
                    <div class="col-12 col-md-4 offset-md-4" >
                        
                        <button 
                            type="button" 
                            class="btn btn-primary btn-facebook w-100 mt-2" 
                            @click="fblogin"
                            v-if=" data.authResponse.accessToken != '' "
                        >
                            <span> <img :src="data.profile.profilePicture" /> </span> 
                            Continue as {{data.profile.firstname}}
                        </button>
                        
                    </div>
                    
                    <div class="col-12 col-md-4 offset-md-4 mt-5" v-if=" data.authResponse.accessToken != '' " >
                        
                        <h4 class="col-12" > Logged in as {{data.profile.firstname}} {{data.profile.lastname}} </h4>
                        
                        <p class="mt-2" >
                            Access Token expires at {{ formatData( data.authResponse.data_access_expiration_time ) }}
                        </p>
                        
                        <button 
                            type="button" 
                            class="btn btn-outline-primary btn-facebook w-100 mt-2" 
                            @click="submit"
                            v-if=" data.authResponse.accessToken != '' "
                        >
                            Save integration
                        </button>
                        
                        <br>
                        <button 
                            type="button" 
                            class="btn btn-danger btn-facebook mt-2 w-100" 
                            @click="fblogout"
                            v-if=" data.authResponse.accessToken != '' "
                        >
                            Not {{data.profile.firstname}}? Logout
                        </button>
                        
                    </div>
                        
                    
                </div>
                
                <div v-if="integrating"  class="col-12 mt-4" >
                    <p class="text-center font-weight-bold" > Setting everything up. Might take a while... </p>
                    <spinner type="small" ></spinner>
                </div>
                
                
            </div>
            
            <b-card no-body class="col-12 mt-2 atlass-tabs" v-if="type == 'edit' " >
                <b-tabs card  >
                    
                    <b-tab @click="goBack" class="p-0" >
                        <template #title>
                            <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back
                        </template>
                    </b-tab>
                    
                    <b-tab title="Overview" class="p-0" active>
                        <b-card-text>
                            
                            <spinner v-if="!tabloaded" ></spinner>
                            
                            <div v-if="tabloaded"  >
                                
                                <!-- FACEBOOK ACCOUNT SECTION -->
                                <div class="w-100" >
                                    
                                    <div class="col-12 border-bottom-gray pb-2 mb-4 " >
                                        <span class="d-inline-block line-height-31" > <h2 class="h2 font-weight-bold line-height-31" > Facebook Account </h2> </span>
                                        <button 
                                            type="button" 
                                            class="btn btn-danger w-auto btn-sm float-right" 
                                            @click="fblogout"
                                            v-if=" data.authResponse.accessToken != '' "
                                        >
                                            Not {{data.profile.firstname}}? Logout
                                        </button>
                                    </div>

                                    <div class="col-12 mt-4" >
                                        <div class="row" >

                                            <div class="col-12 " >

                                                <div class="mt-1" >

                                                    <button 
                                                        type="button" 
                                                        class="btn btn-primary btn-facebook" 
                                                        @click="fblogin"
                                                        v-if=" data.authResponse.accessToken == '' "
                                                    >
                                                        <span><font-awesome-icon :icon="['fab', 'facebook']" /></span> 
                                                        Log in With Facebook
                                                    </button>

                                                    <button 
                                                        type="button" 
                                                        class="btn btn-primary btn-facebook d-none" 
                                                        @click="fblogin"
                                                        v-if=" data.authResponse.accessToken != '' "
                                                    >
                                                        <span> <img :src="data.profile.profilePicture" /> </span> 
                                                        Continue as {{data.profile.firstname}}
                                                    </button>

                                                    <div class="row col-12 pl-0 pr-0" v-if=" data.authResponse.accessToken != '' " >
                                                        <div class="col-2" >
                                                            <span> <img :src="data.profile.profilePicture"  class="w-100" /> </span> 
                                                        </div>
                                                        <div class="col-10" >
                                                            <div class="w-100 mt-3 font-size-16" >
                                                                Logged in as <b> {{data.profile.firstname}}  {{data.profile.lastname}} </b>
                                                            </div>

                                                            <div class="w-100 mt-4" >
                                                                <span v-if="data.LongLiveToken" >
                                                                    Access Token expires {{ formatData( data.LongLiveToken.expires_at, 'to' ) }}, at {{ formatData( data.LongLiveToken.expires_at ) }}
                                                                </span>
                                                                <span v-else-if="!data.LongLiveToken" >
                                                                    Access Token missing
                                                                </span>
                                                                
                                                                <br>
                                                                <button 
                                                                    type="button" 
                                                                    class="btn btn-primary btn-sm" 
                                                                    @click="FB_getLongLiveToken( null )"
                                                                >
                                                                   Refresh Access Token
                                                                </button>
                                                            </div>

                                                        </div>



                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    
                                </div>
                                
                                <!-- INTEGRATION SECTION -->
                                <div class="w-100 mt-5" >
                                    
                                    <div class="col-12 border-bottom-gray pb-2 mb-4 " >
                                        <span class="d-inline-block line-height-31" > <h2 class="h2 font-weight-bold line-height-31" > Integration Details </h2> </span>
                                        <span class="d-inline-block line-height-31 float-right" > 
                                            <font-awesome-icon :icon="['fas', 'check-circle']" v-if="data.Status" class="font-size-16 color-green" /> 
                                            <span v-if="data.Status" > Active </span>
                                            <span v-else-if="!data.Status" > Inactive </span>
                                        </span>
                                    </div>

                                    <div class="col-12 mt-3" >
                                        <div class="row" >
                                            <div class="col-12 col-md-10" >
                                                <h2 class="h3 font-weight-bold line-height-31" > Attribute campaigns </h2>
                                                <p class="mt-1" >
                                                    This will pull all ads from your enabled ad accounts in order to render the analyze dashboard.
                                                </p>
                                            </div>
                                            <div class="col-12 col-md-2 text-right" >
                                                <b-form-checkbox v-model="data.settings.attribute_campaigns" name="check-button" @change="toggleSwitch( 'attribute_campaigns', data.settings.attribute_campaigns )" class="cursor-pointer d-inline-block" switch > </b-form-checkbox>
                                                <span v-if="data.settings.attribute_campaigns" > Active </span>
                                                <span v-else-if="!data.settings.attribute_campaigns" > Inactive </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 mt-5 d-none" >
                                        <div class="row" >
                                            <div class="col-12 col-md-10" >
                                                <h2 class="h3 font-weight-bold line-height-31" > Offline conversions </h2>
                                                <p class="mt-1" >
                                                    This action will send the conversions back to Facebook as offline conversions. <br>
                                                    
                                                    <b-alert show variant="danger">
                                                        <b>Important!</b>
                                                        Please don't activate this until we make sure tracking and attribution is confirmed.
                                                    </b-alert>
                                                </p>
                                            </div>
                                            <div class="col-12 col-md-2 text-right" >
                                                <b-form-checkbox v-model="data.settings.offline_conversions" name="check-button" @change="toggleSwitch( 'offline_conversions', data.settings.offline_conversions )" class="cursor-pointer d-inline-block" switch > </b-form-checkbox>
                                                <span v-if="data.settings.offline_conversions" > Active </span>
                                                <span v-else-if="!data.settings.offline_conversions" > Inactive </span>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                                <!-- INTEGRATION SECTION -->
                                
                            </div>
                            
                        </b-card-text>
                    </b-tab>
                    
                    <b-tab title="Ad Accounts" @click="get_adaccounts" class="p-0"  >
                        
                        <spinner v-if="!tabloaded" ></spinner>
                        
                        <div v-if="tabloaded"  >

                            <div class="col-12 border-bottom-gray pb-2 mb-4" >
                                <span class="d-inline-block line-height-31" > <h2 class="h2 line-height-31" > Connected Ad accounts </h2> </span>

                                <button type="button"  class="btn btn-outline-primary btn-sm float-right"  @click="get_adaccounts( )"
                                    v-if=" data.authResponse.accessToken != '' "
                                >
                                    Refresh
                                </button>
                                
                                <button type="button"  class="btn btn-primary btn-sm float-right mr-1"  @click="FB_importAdAccounts"
                                    v-if=" data.authResponse.accessToken != '' "
                                >
                                    Import ad accounts
                                </button>

                            </div>
                            
                            <div class="col-12" >
                                
                                <div class="row" >
                                    <div class="col-12" >
                                        <b-input-group>
                                            <b-form-input v-model="filter" placeholder="Search Ad Accounts" class="search-input atlass-input-borderless" />
                                            <font-awesome-icon icon="times-circle" @click="filter = ''" class="reset-filter" v-bind:class="{ 'd-none' : !filter }" >Clear</font-awesome-icon>
                                        </b-input-group>
                                    </div>
                                </div>
                                
                                <vue-good-table
                                v-if="AdAccounts"
                                :columns="columns"
                                :rows="AdAccounts"
                                styleClass="vgt-table atlass-datatable mb-3"
                                :search-options="{ enabled: true, externalQuery: filter }"
                                :pagination-options="{ 
                                    enabled: true,
                                    perPage: 15,
                                    perPageDropdown: [50, 100],
                                    ropdownAllowAll: true,
                                    nextLabel: 'next',
                                    prevLabel: 'prev',
                                    rowsPerPageLabel: 'Ad accounts per page',
                                    ofLabel: 'of',
                                    pageLabel: 'page', // for 'pages' mode
                                    allLabel: 'All',
                                }"
                                :selectOptions="{
                                    enabled: false,
                                    selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                  }"
                                
                                 >

                                <template slot="table-row" slot-scope="props">
                                    <span v-if="props.column.field == 'Status'">
                                        
                                        <b-form-checkbox v-model="props.row.Status" name="check-button" class="cursor-pointer d-inline-block" switch @change="changeAdAccountStatus(props.row)" > </b-form-checkbox>
                                        <span v-if="props.row.Status" >  </span>
                                        <span v-else-if="!props.row.Status" >  </span>
                                        
                                    </span>
                                    <span v-else-if="props.column.field == 'Ads'">
                                        
                                        <a @click="FB_listAdAccountsAds(props.row)" class="cursor" > <font-awesome-icon icon="list"  /> </a>
                                        
                                    </span>
                                    <span v-else  >
                                        {{props.formattedRow[props.column.field]}}
                                    </span>
                                </template>

                            </vue-good-table>
                                
                            </div>
                            
                        </div>
                        
                    </b-tab>
                    
                </b-tabs>
            </b-card>

            <modal :modalData="modalData" :modalState="modalState" modalComponent="ads" ></modal>

        </div>
        
    </div>
</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
import helper from '@/helpers/helpers.js';
    
import modal from '@/components/modal.vue'  
    
export default {
    name: 'FACEBOOK',
    components:{
        modal
    },
    props: {
        ID:{
            type: [String]
        }
    },
    data: function(){
        return {
            loaded: false, 
            data:{
                "APP": "FACEBOOK",
                Name: "Facebook Integration",
                Tag: "facebook",
                "Type" : 'ads',
                profile: { firstname: '', lastname: '', profilePicture: "", id: "" },
                authResponse: {
                    accessToken: "",
                    data_access_expiration_time: '',
                    expiresIn: '',
                    graphDomain: "",
                    signedRequest: '',
                    userID: ''
                },
                Status: true,
            },
            AdAccounts: [],
            tabloaded: true,
            isConnected: false,
            FB_Connected: { firstname: '', lastname: '', profilePicture: "" },
            type: 'edit',
            editable: false,
            checkingIntegration: false,
            integrating: false,
            modalState: false,
            modalData: null,
            filter: '',
            columns: [
                {
                    label: 'NAME',
                    field: 'name',
                    tdClass: 'font-weight-bold',
                },
                /*
                {
                    label: 'ACCOUNT ID',
                    field: 'account_id'
                    //field: this.renderTag
                },
                */
                {
                    label: 'STATUS',
                    field: 'Status',
                    sortable: false,
                    tdClass: 'text-center',
                    thClass: 'text-center',
                },
                {
                    label: 'ADS',
                    field: 'Ads',
                    sortable: false,
                    tdClass: 'text-center',
                    thClass: 'text-center',
                },
            ],
        }
    },
    beforeCreate: function () {
    },
    created: function () {

    },
    mounted: function () {      

        if( this.ID == 'new' ){
            this.loaded = true
            this.editable = true
            this.type = 'add'
            
            if( this.data.authResponse.accessToken == ''  ){
            
                if (typeof FB === "undefined") {
                    console.log('init')
                    this.FB_init();
                } else {
                    console.log('parse')
                    window.FB.XFBML.parse();
                    
                    const vm = this
                    FB.getLoginStatus((response) => {   // Called after the JS SDK has been initialized.
                        console.log(response)
                        vm.statusChangeCallback(response); // Returns the login status.
                    }, true );
                    
                }
                
            }
            
        }else{
            this.get_data( this.ID );
            
            if (typeof FB === "undefined") {
                console.log('init')
                //this.FB_init();
            } else {
                console.log('parse')
                window.FB.XFBML.parse();

                const vm = this
                FB.getLoginStatus((response) => {   // Called after the JS SDK has been initialized.
                    console.log(response)
                    vm.statusChangeCallback(response); // Returns the login status.
                }, true );

            }
            
        }
        
        
        
    },
    beforeDestroy() {
    },
    methods: {
        //FACEBOOK
        FB_init(){
            
            //console.log("INIT")
            const vm = this
            
            window.fbAsyncInit = function() {
                FB.init({
                  appId      : '2433573743603710',
                  cookie     : true,                     // Enable cookies to allow the server to access the session.
                  status     : true,                     // Enable cookies to allow the server to access the session.
                  xfbml      : true,                     // Parse social plugins on this webpage.
                  version    : 'v12.0'           // Use this Graph API version for this call.
                });

                //const vm = this
                FB.getLoginStatus((response) => {   // Called after the JS SDK has been initialized.
                    //vm.statusChangeCallback(response); // Returns the login status.
                    console.log(response)
                }, true );
                
                //FB.AppEvents.logPageView();
            };
            
            
            (function(d, s, id) {                      // Load the SDK asynchronously
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));

            
        },
        statusChangeCallback(response){
			if(response.status === 'connected'){
                
				console.log('Logged in and authenticated');
                console.log(response)
                this.data.authResponse = response.authResponse
                this.FB_getLoggedIn()
				//this.fetchData();

            } else {
                this.isConnected = false
				console.log('Not authenticated');
                this.fblogin();
			}
		},
        
        fblogin(){
            FB.login((response) => {
                console.log(response)
                if (response.status === 'connected') {
                    this.statusChangeCallback( response )
                    //fetchData
                    console.log("loggedin")
                    this.FB_getLoggedIn()
                    // Logged into your webpage and Facebook.
                    console.log("checking permissions")
                    FB.api('/me/permissions', (response) => {
                        console.log(response)
                    })
                    
                } else {
                    // The person is not logged into your webpage or we are unable to tell. 
                    console.log("Could not login")
                }
            },{ scope:"public_profile,pages_show_list,pages_read_engagement,ads_read,business_management,attribution_read", auth_type: 'rerequest'});
            
            //console.log(this.name)
            
        },
        
        FB_getpermissions(){
          
            FB.getLoginStatus((response) => {   // Called after the JS SDK has been initialized.
                //vm.statusChangeCallback(response); // Returns the login status.
                console.log("checking permissions")
                FB.api('/me/permissions', (response) => {
                    console.log(response)
                })

            }, true );
            
        },
        
        FB_getLoggedIn(){
            
            const vm = this
            FB.api('/me?fields=id,first_name,last_name,email,picture.width(300).height(300) ', (response) => {
                console.log(response)
                if(response && !response.error){
                    this.data.profile.firstname = response.first_name
                    this.data.profile.lastname = response.last_name
                    this.data.profile.id = response.id
                    this.data.profile.profilePicture = response.picture.data.url

                    //SAVE TO DB
                    if( this.type == 'edit' ){
                        let document = this.data
                        document.last_update = Math.round(+new Date()/1000)
                        /*
                        let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
                        let ref = this.$firebase.firestore().collection('organizations/'+orgID+'/integrations').doc( this.data.docID )
                        return ref.set( document, { merge: true } )
                        */
                    }
                    //SAVE TO DB
                    
                    //this.FB_listAdAccounts()
                }
            })
            
        },
       
        FB_importAdAccounts(){
            
            this.tabloaded = false
            this.FB_listAdAccounts()
            
            
        },
        
        FB_listAdAccountsAds( ACCOUNT ){
            console.log( ACCOUNT )
            
            this.$toast.info({
                title:'Processing',
                message: 'Gettings ads. This might take a while',
                timeOut: 8000
            })
            
            this.FB_getAdsFromAdAccount( ACCOUNT )
            
        },
        
        FB_getLongLiveToken( docID = null ){
            
            //IN ORDER TO REFRESH THE TOKEN, FIRST GET A VALID ACESS TOKEN ( valid for 1-2 hours )
            
            FB.getLoginStatus(function(response) {
                //statusChangeCallback(response);
                console.log(response)
                console.log("checking permissions")
                FB.api('/me/permissions', (response) => {
                    console.log(response)
                })
            })
            
            
            let params = Cookies.get('user-token')
            
            if( docID == null ){
                docID = this.ID
            }
            
            let data = { "APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ), "integrationID": docID }
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "X-Auth": params }
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/integrations/facebook/get-token', headers: headers, data: data })
                .then(resp => {
                                
                if( resp.status == 200 ){
                    let r = resp.data;
                                        
                    let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
                    let ref = this.$firebase.firestore().collection('organizations/'+orgID+'/integrations').doc( this.ID )

                    let longLive = JSON.parse(r.body)
                    longLive.created_at = Math.round(+new Date()/1000)
                    longLive.expires_at = Math.round(+new Date()/1000) + longLive.expires_in
                    
                    this.data.LongLiveToken = longLive
                    
                    this.$toast.success({
                        title:'Success',
                        message: 'Token saved'
                    })
                    
                    return ref.update( { LongLiveToken: this.data.LongLiveToken } )
                    
                }
                
            })
            .then((result)=>{
                this.get_data( docID )
            })
            .catch(error => {
                console.log(error)
                
                this.$toast.error({
                    title:'Error',
                    message: 'Could not get long live token'
                })
                
            }); //end axios 
           
            
        },
        
        FB_getAdsFromAdAccount( account ){
            
            let params = Cookies.get('user-token')
            
            let docID = this.ID
            
            let data = { "APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ), "integrationID": docID, "account": account }
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "X-Auth": params }
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/integrations/facebook/get-ads', headers: headers, data: data })
                .then(resp => {
                                
                if( resp.status == 200 ){
                    let r = resp.data;
                                        
                    if( r.body.length > 0 ){
                        
                        this.$toast.success({
                            title:'Success',
                            message: 'Ads fetched'
                        })
                        
                        this.modalState = true;
                        this.modalData = r.body
                    }else{
                        
                        this.$toast.success({
                            title:'Success',
                            message: 'No active ads in this account'
                        })
                        
                    }
                    
                }
                
            }).catch(error => {
                console.log(error)
                
                this.$toast.error({
                    title:'Error',
                    message: 'Could not get ads'
                })
                
            }); //end axios 
            
        },
        
        FB_listAdAccounts( docID = null ){
            
            let params = Cookies.get('user-token')
            
            if( docID == null ){
                docID = this.ID
            }
            
            
            let data = { "APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ), "integrationID": docID }
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "X-Auth": params }
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/integrations/facebook/get-adaccounts', headers: headers, data: data })
                .then(resp => {
                                
                if( resp.status == 200 ){
                    let r = resp.data;
                    console.log(r)                    
                    
                    this.$toast.info({
                        title:'Importing',
                        message: 'Ad accounts are being imported. This might take a while...'
                    })
                    
                    let done = false;
                    r.body.adaccounts.data.forEach(async (account, index)=>{
                        account.Status = false
                        
                        //if( account.account_status == 1 ){                           
                        if( account.account_status == 1 ){                           
                            //IF AD ACCOUNT IS ACTIVE
                            
                            const found = this.AdAccounts.find(el => el.account_id === account.account_id );
                            if( !found ){
                                //console.log('new ad account: '+ account.account_id)
                                this.AdAccounts.push(account)
                                let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
                                return await this.$firebase.firestore().collection('organizations/'+orgID+'/integrations/'+this.data.docID+'/AdAccounts')
                                    .doc( account.account_id )
                                    .set( account, { merge: true } )
                                
                            }
                                
                        }
                        
                        if( index == r.body.adaccounts.data.length - 1 ){
                            done = true
                        }
                        
                    })
                                        
                    this.tabloaded = true
                    
                    if( done ){
                        this.$toast.success({
                            title:'Imported',
                            message: 'Ad accounts have been imported'
                        })
                    }
                    
                }
                
            })
            .catch(error => {
                console.log(error)
                
                this.$toast.error({
                    title:'Error',
                    message: 'Could not import ad accounts'
                })
                this.tabloaded = true
            }); //end axios 
            
            
        },
        
        fblogout(){
            
            if (typeof FB === "undefined") {
                console.log('init')
                this.FB_init();
            } else {
                console.log('parse')
                window.FB.XFBML.parse();
            }
            
            const vm = this
            FB.getLoginStatus((response) => {   // Called after the JS SDK has been initialized.
                
                FB.logout( (response) => {

                    console.log('Logged out');

                    this.isConnected = false
                    this.data.profile = { firstname: '', lastname: '', profilePicture: "", id: "" }
                    this.data.authResponse =  {
                        accessToken: "",
                        data_access_expiration_time: '',
                        expiresIn: '',
                        graphDomain: "",
                        signedRequest: '',
                        userID: ''
                    }
                    /*
                    if( this.type == 'edit' ){
                        vm.submit()
                    }
                    */
                    if( this.type == 'edit' ){
                        this.delete()
                    }


                });

            }, true );
            
        },
        //FACEBOOK
        
        goBack(){
            this.$router.push({
                name: "Integration",
                params: { APP: 'FACEBOOK' }
            });
        },
        get_data( ID, createWebhooks = false ){
          
            this.tabloaded = false
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = this.$firebase.firestore();
            
            var ref = db.collection('organizations/'+orgID+'/integrations').doc( ID )
                                    
            return ref.get()
                .then((snapshot) => {
                    if( snapshot.exists ){
                        console.log(snapshot.data())
                        this.data = snapshot.data()
                        this.data.docID = snapshot.id
                        this.type = 'edit'
                    }else{
                        console.log("No integration set")
                        this.$router.push({
                            name: "Integrations",
                        });
                    }
                    
                    this.loaded = true;
                    this.tabloaded = true
                    //if( createWebhooks ){ this.createWebhooks() }
                })
          
        },
        
        get_adaccounts(  ){
          
            this.tabloaded = false
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = this.$firebase.firestore();
            
            var ref = db.collection('organizations/'+orgID+'/integrations/'+this.data.docID+'/AdAccounts')
                                    
            return ref.get()
                .then((results) => {
                    
                    this.AdAccounts = [];
                
                    results.forEach((account)=>{
                        this.AdAccounts.push( account.data() )
                    })
                    this.tabloaded = true
                    //if( createWebhooks ){ this.createWebhooks() }
                })
          
        },
        formatData(unix, to = false ){
            
            if( to ){
                let date = this.$moment.unix(unix).format( 'MMM D YYYY, HH:mm' )
                return this.$moment().to( date )
            }else{
                return this.$moment.unix(unix).format( 'MMM D YYYY, HH:mm' )
            }
            
            
        },
        edit(){
            this.editable = !this.editable
        },
        
        changeAdAccountStatus( account ){
            
            account.Status = !account.Status
            console.log( account.Status )
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            this.$firebase.firestore().collection('organizations/'+orgID+'/integrations/'+this.data.docID+'/AdAccounts').doc( account.account_id )
                .update( { Status: account.Status } )
                .then((result)=>{
                    this.$toast.success({
                        title:'Success',
                        message: 'Ad account updated'
                    })
                })
            
            
        },
        
        submit(){
                        
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            const db = this.$firebase.firestore();
            
            let document = this.data

            //console.log(document)
            
            if( this.type == 'add' ){
                
                let settings = {}
                settings.attribute_campaigns = true
                settings.offline_conversions = false

                document.settings = settings
                
                this.integrating = true
                
                document.datetime = Math.round(+new Date()/1000)
                    
                let ref = this.$firebase.firestore().collection('organizations/'+orgID+'/integrations')
                
                return ref.add( document )
                 .then((result)=>{
                    let docID = result.id
                    
                    console.log(docID)
                    
                    this.FB_getLongLiveToken(docID)
                    
                    this.$toast.success({
                        title:'Success',
                        message: 'Integration successful'
                    })                    
                    
                    //this.FB_listAdAccounts( docID )
                    
                    this.$router.push({
                        name: this.data.APP,
                        params: { ID: docID }
                    }); 
                    
                    this.editable = false
                    
                })
                .then((docID)=>{
                    
                    
                    
                })
                
            }else{
                
                document.last_update = Math.round(+new Date()/1000)
                    
                let ref = this.$firebase.firestore().collection('organizations/'+orgID+'/integrations').doc( this.data.docID )
                
                return ref.set( document, { merge: true } )
                .then((result)=>{
                    
                    this.$toast.success({
                        title:'Success',
                        message: 'Changed saved '
                    })
                    
                    this.loaded = true
                    
                })
                
            }

            
        },       
        
        toggleSwitch( field, value ){
            
            let document = {}
            let update = true;
            
            console.log(this.data)
            
            if( field == 'Status' ){
                this.data.Status = value
                document.Status = value
            }else if( field == 'attribute_campaigns' ){
                document['settings.attribute_campaigns'] = !this.data.settings.attribute_campaigns
            }else if( field == 'offline_conversions' ){
                document['settings.offline_conversions'] = !this.data.settings.offline_conversions
            }
            
            document.last_update = Math.round(+new Date()/1000)
            
            if( update ){
                //UPDATE FIRESTORE
                let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
                const db = this.$firebase.firestore();
                let ref = db.collection('organizations/'+orgID+'/integrations').doc( this.data.docID )

                return ref.update( document )
                .then((result)=>{
                    this.$toast.success({
                        title:'Success',
                        message: 'Changed saved '
                    })
                })
            }
            
        },//end toggleSwitch

        preventDelete( ){
            
            this.$swal({
                title: 'Are you sure?',
                text: 'This cannot be undone and the conversion will be deleted as well',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) { 
                    
                    this.delete( );
                    
                }
            })
            
        },        
        delete: function( ){
            
            this.loaded = false
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = firebase.firestore();
            
            let ref = db.collection('organizations/'+orgID+'/integrations').doc( this.ID )
            return ref.delete()
            .then(function(){

                 this.$toast.success({
                    title: 'Success',
                    message: 'Integration deleted'
                })
                
                firebase.firestore().collection('organizations/'+orgID+'/integrations/'+this.ID+'/AdAccounts').get()
                .then((results)=>{
                    results.forEach((result)=>{
                        firebase.firestore().collection('organizations/'+orgID+'/integrations/'+this.ID+'/AdAccounts').doc( result.id ).delete()
                    })
                    
                    
                    
                })
                
                setTimeout(function(){ 
                    this.loaded = true
                    this.$router.push({
                        name: 'Integrations'
                    }); 
                }.bind(this), this.timeout );

            }.bind(this))
            .catch(function(error){

                //console.error("Error updating document: ", error);
                this.$toast.error({
                    title: 'Error',
                    message: "Something went wrong: "+error
                })

                this.loaded = true

            }.bind(this))
            
        },
        
    },
    watch: {
        ID: function(){
            this.docID = this.ID
            //this.get_data();
            
            //this.$refs.tags.$el.click()
            
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
    .v-facebook-login{
        margin: auto!important;
    }
    
    .btn-facebook{
        width: 100%;
        font-size: 1.1rem;
        font-weight: bold;
        padding: .6rem 1.5rem
    }
    .btn-facebook svg{
        margin-right: 10px;
        font-size: 23px;
    }
    .btn-facebook img{
        margin-right: 10px;
        width:23px;
        height:23px;
        border-radius: 50%;
    }
    
    .tab-pane{
        margin-top: 2rem;
    }
    
    
</style>



// WEBPACK FOOTER //
// src/templates/setup/integrations/FACEBOOK.vue